import { Component, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdsShopSelectionComponent } from '../ads-shop-selection/ads-shop-selection.component';
import { AdsFileUploadComponent } from '../ads-file-upload/ads-file-upload.component';
import { AdsSettingsService } from '../../ads-settings-service.service';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-ads-settings-edit',
  templateUrl: './ads-settings-edit.component.html',
  styleUrl: './ads-settings-edit.component.scss',
  standalone: false
})
export class AdsSettingsEditComponent implements OnInit, AfterViewInit {
  @ViewChild('shopSelection') shopSelectionComponent!: AdsShopSelectionComponent;
  @ViewChild('fileUpload') fileUploadComponent!: AdsFileUploadComponent;
  adsInfo: number = 0;
  adTitle: string = '';

  constructor(
    private route: ActivatedRoute,
    private adsSettingsService: AdsSettingsService,
    private snackBarService: SnackBarService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.adsInfo = Number(params.get('id'));
    });
  }

  ngAfterViewInit() {
    if (this.adsInfo > 0) {
      setTimeout(() => this.loadAdData(), 0);
    }
  }

  loadAdData() {
    this.adsSettingsService.getAdById(this.adsInfo).subscribe(res => {
      if (res.status === 'SUCCESS') {
        const ad = res.data.ad;
        const details = ad.details || [];
        this.adTitle = ad.title;

        if (this.fileUploadComponent) {
          const mediaTypeNum = ad.media_type ?? 1;
          const mediaTypeStr = mediaTypeNum == 1 ? 'image' : 'video';

          this.fileUploadComponent.adForm.patchValue({
            adTitle: ad.title,
            startDate: ad.period_from,
            endDate: ad.period_to,
            mediaType: mediaTypeStr
          });

          if (mediaTypeStr === 'image' && ad.duration) {
            this.fileUploadComponent.adForm.patchValue({
              imageDuration: Number(ad.duration)
            });
          }

          if (mediaTypeStr === 'video' && ad.mute_video !== undefined && ad.mute_video !== null) {
            this.fileUploadComponent.adForm.patchValue({
              muteVideo: ad.mute_video == 1
            });
          }

          if (details.length > 0 && details[0].media_file_name) {
            const fileNames = details[0].media_file_name.split(',');
            const baseUrl = environment.assetsUrl + environment.assetsPosAdsPath;

            this.fileUploadComponent.serverMedia = fileNames.map((name: string) => ({
              name: name.trim(),
              url: baseUrl + "/" + name.trim()
            }));
          }
        }

        if (this.shopSelectionComponent) {
          const shopIds = details.map((d: any) => d.shop_id);
          this.shopSelectionComponent.setSelectedShops(shopIds);
        }
      } else {
        this.snackBarService.openSnackBar({
          title: 'Error',
          message: res.message || 'Error loading ad context.',
          type: 'error'
        });
      }
    });
  }

  isFormDirty(): boolean {
    let dirty = false;
    if (this.fileUploadComponent && this.fileUploadComponent.isDirty()) {
      dirty = true;
    }
    if (this.shopSelectionComponent && this.shopSelectionComponent.isDirty) {
      dirty = true;
    }
    return dirty;
  }

  navBack() {
    if (this.isFormDirty()) {
      const dialogData = new ConfirmDialogModel("Confirm Discard", "You have unsaved changes. Are you sure you want to discard them?");
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        maxWidth: "400px",
        data: dialogData
      });

      dialogRef.afterClosed().subscribe(dialogResult => {
        if (dialogResult) {
          window.history.back();
        }
      });
    } else {
      window.history.back();
    }
  }

  update() {
    if (!this.fileUploadComponent) return;

    this.fileUploadComponent.selectedShops =
      this.shopSelectionComponent?.selectedShops || [];

    this.fileUploadComponent.update();
  }
}
